import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const PAGE_SIZE = 10;
export const PAGE_BATCH_SIZE = 5;

function Pagination(props) {
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    const currentPage = parseInt(query.get('page') || '1', 10);
    const totalPages = Math.ceil(props.count / PAGE_SIZE);

    function getPageClass(page) {
        return page === currentPage ? "page-item active" : "page-item";
    }

    function getPageLink(page) {
        return `${window.location.pathname}?page=${page}`;
    }

    function renderPages() {
        const pages = [];
        const start = Math.max(2, currentPage - PAGE_BATCH_SIZE);
        const end = Math.min(totalPages - 1, currentPage + PAGE_BATCH_SIZE);

        // Primeira página sempre visível
        pages.push(
            <li key={1} className={getPageClass(1)}>
                <Link className="page-link" to={getPageLink(1)}>1</Link>
            </li>
        );

        // Elipses antes do bloco de páginas
        if (start > 2) {
            pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }

        // Páginas intermediárias
        for (let i = start; i <= end; i++) {
            pages.push(
                <li key={i} className={getPageClass(i)}>
                    <Link className="page-link" to={getPageLink(i)}>{i}</Link>
                </li>
            );
        }

        // Elipses após o bloco de páginas
        if (end < totalPages - 1) {
            pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }

        // Última página sempre visível
        if (totalPages > 1) {
            pages.push(
                <li key={totalPages} className={getPageClass(totalPages)}>
                    <Link className="page-link" to={getPageLink(totalPages)}>{totalPages}</Link>
                </li>
            );
        }

        return pages;
    }

    return (
        <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-center">
            <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                    {/* Botão 'Fast Return' */}
                    <li className={`page-item ${currentPage <= PAGE_BATCH_SIZE ? "disabled" : ""}`}>
                        <Link
                            className="page-link"
                            to={getPageLink(Math.max(1, currentPage - PAGE_BATCH_SIZE))}
                        >
                            <svg className="icon icon-xs" aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.75 19.5L12 12l6.75-7.5M11.25 19.5L4.5 12l6.75-7.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </Link>
                    </li>

                    {/* Botão 'Anterior' */}
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <Link className="page-link" to={getPageLink(currentPage - 1)}>
                        <svg className="icon icon-xs" aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.75 19.5L8.25 12l7.5-7.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        </Link>
                    </li>

                    {/* Páginas com elipses */}
                    {renderPages()}

                    {/* Botão 'Próximo' */}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <Link className="page-link" to={getPageLink(currentPage + 1)}>
                        <svg className="icon icon-xs" aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.25 4.5L15.75 12l-7.5 7.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        </Link>
                    </li>

                    {/* Botão 'Fast Forward' */}
                    <li className={`page-item ${currentPage + PAGE_BATCH_SIZE > totalPages ? "disabled" : ""}`}>
                        <Link
                            className="page-link"
                            to={getPageLink(Math.min(totalPages, currentPage + PAGE_BATCH_SIZE))}
                        >
                        <svg className="icon icon-xs" aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.25 4.5L12 12l-6.75 7.5M12.75 4.5L19.5 12l-6.75 7.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default Pagination;



/* Beholder Original
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const PAGE_SIZE = 10;

/**
 * props:
 * - count

function Pagination(props) {

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    function getPageClass(page) {
        const queryPage = query.get('page');
        // eslint-disable-next-line
        const isActive = queryPage == page || (!queryPage && page === 1);
        return isActive ? "page-item active" : "page-item";
    }

    function getPageLink(page) {
        return `${window.location.pathname}?page=${page}`;
    }

    let pagesQty = Math.ceil(props.count / PAGE_SIZE);
    pagesQty = pagesQty > 10 ? 10 : pagesQty;
    const pages = [];
    for (let i = 1; i <= pagesQty; i++)
        pages.push(i);

    function getBottom() {
        if (props.count > 100)
            return (<div className="fw-normal small mt-4 mt-lg-0"><b>{props.count}</b> results. First <b>10</b> pages.</div>);
        else if (props.count > 0)
            return (<div className="fw-normal small mt-4 mt-lg-0"><b>{props.count}</b> results.</div>);
        else
            return (<div className="fw-normal small mt-4 mt-lg-0"><b>No results found.</b> Create one first.</div>);
    }

    return (
        <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
            <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                    {
                        pages.map(p => (
                            <li key={p} className={getPageClass(p)}>
                                <Link className="page-link" to={getPageLink(p)}>{p}</Link>
                            </li>
                        ))
                    }
                </ul>
            </nav>
            {getBottom()}
        </div>
    )
}

export default Pagination; */